import { API_BASE_URL as BASE } from './apiConfig';
import { createAuthedAxios } from '@/lib/authedAxios';

const API_BASE_URL = `${BASE}/api/notifications`;

const client = createAuthedAxios();

export interface UserNotification {
  id: number;
  type: string;
  title: string;
  message: string | null;
  link: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface UserNotificationListData {
  items: UserNotification[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  unreadCount: number;
}

export const notificationApi = {
  list: async (page = 0, size = 20): Promise<UserNotificationListData> => {
    const response = await client.get<{ success: boolean; data: UserNotificationListData }>(API_BASE_URL, {
      params: { page, size },
    });
    return response.data.data;
  },

  unreadCount: async (): Promise<number> => {
    const response = await client.get<{ success: boolean; data: { unreadCount: number } }>(`${API_BASE_URL}/unread-count`);
    return response.data.data.unreadCount;
  },

  markAsRead: async (id: number): Promise<void> => {
    await client.patch(`${API_BASE_URL}/${id}/read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await client.patch(`${API_BASE_URL}/read-all`);
  },
};
